import '../css/tailwind.css';

import 'core-js/actual';

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import app from "./bootstrap-backoffice.js";

import loadImage from "blueimp-load-image/js/load-image.js";
window.loadImage = loadImage;
import "blueimp-load-image/js/load-image-scale.js";
import "blueimp-load-image/js/load-image-meta.js";
import "blueimp-load-image/js/load-image-fetch.js";
import "blueimp-load-image/js/load-image-exif.js";
import "blueimp-load-image/js/load-image-exif-map.js";
import "blueimp-load-image/js/load-image-orientation.js";

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import i18n from "./i18n";
app.use(i18n)


import PortalVue from 'portal-vue'
app.use(PortalVue)

import { ZiggyVue } from '../../vendor/tightenco/ziggy';
app.use(ZiggyVue);

import WordHighlighter from "vue-word-highlighter";
app.component("text-highlight", WordHighlighter);

import QrcodeVue from "./components/ui/Qrcode.vue";
app.component("dtc-qrcode", QrcodeVue);
import ToggleVisibility from "./components/ui/ToggleVisibility.vue"
app.component("toggle-visibility", ToggleVisibility);

import CopyToClipboard from "./components/ui/CopyToClipboard.vue"
app.component("copy-to-clipboard", CopyToClipboard);
import TokenExpirationPicker from "./components/ui/TokenExpirationPicker.vue"
app.component("token-expiration-picker", TokenExpirationPicker);

import { ConfirmDialog, ConfirmButton, ConfirmBanner } from "./components/ui/confirm"
app.component("dtc-confirm-dialog", ConfirmDialog);
app.component("dtc-confirm-button", ConfirmButton);
app.component("dtc-confirm-banner", ConfirmBanner);

import FiltersBlade from "./components/filters/FiltersBlade.vue"
app.component("dtc-filters-blade", FiltersBlade);

import BrandStatisticsExport from "./components/brands/BrandStatisticsExport.vue"
app.component("dtc-brand-statistics-export", BrandStatisticsExport);

import ActivityLogForSubject from "./components/activity-log/ActivityLogForSubject.vue"
app.component("dtc-activity-log-for-subject", ActivityLogForSubject);

import AuthenticationLogIndex from "./components/authentication-log/AuthenticationLogIndex.vue"
app.component("dtc-authentication-log-index", AuthenticationLogIndex);

import DateRange from "./components/DateRange.vue"
app.component("dtc-date-range", DateRange);

import BookingSearch from "./components/booking/BookingSearch.vue"
app.component("dtc-booking-search", BookingSearch);
import BookingForm from "./components/booking/BookingForm.vue"
app.component("dtc-booking-form", BookingForm);
import BookingCreate from "./components/booking/BookingCreate.vue"
app.component("dtc-booking-create", BookingCreate);

import SlotsConfiguration from "./components/slot-config/SlotsConfiguration.vue"
app.component("dtc-slot-config", SlotsConfiguration);

import selector from "./components/registration-settings/countries-selector.vue"
app.component("dtc-countries-selector", selector);

import CaptionBuilder from "./components/registration-settings/CaptionBuilder.vue"
app.component("dtc-registration-caption-builder", CaptionBuilder);

import InventoryEquipmentTable from "./components/inventory/InventoryEquipmentTable.vue"
app.component("dtc-inventory-equipment-table", InventoryEquipmentTable);

import AddEquipmentsDialog from "./components/equipment/AddEquipmentsDialog.vue"
app.component("add-equipments-dialog", AddEquipmentsDialog);
import EquipmentParkSelector from "./components/park/EquipmentParkSelector.vue"
app.component("equipment-park-selector", EquipmentParkSelector);
import ParkTypeLabel from "./components/park/ParkTypeLabel.vue";
app.component("dtc-park-type-label", ParkTypeLabel);

import Fields from "./components/registration-form/Fields.vue"
app.component("dtc-registration-form-fields", Fields);
import Extrafields from "./components/registration-form/Extrafields.vue"
app.component("dtc-registration-extra-fields", Extrafields);

import config from "./components/registration-settings/barcode-config.vue"
app.component("dtc-registration-settings-barcode", config);

import EquipmentBarcode from "./components/form-components/EquipmentBarcode.vue"
app.component("dtc-equipment-barcode-input", EquipmentBarcode);
import BarcodeInput from "./components/form-components/BarcodeInput.vue"
app.component("dtc-barcode-input", BarcodeInput);
import SignatureModal from "./components/signature/SignatureModal.vue"
app.component("dtc-signature-modal", SignatureModal);
import RegistrationRegistrable from "./components/RegistrationRegistrable.vue"
app.component("dtc-registration-registrable", RegistrationRegistrable);

import PlanEditor from "./components/plans/PlanEditor.vue"
app.component("dtc-plan-editor", PlanEditor);
import Heatmap from "@/components/plans/Heatmap.vue";
app.component('dtc-plan-heatmap', Heatmap);

import ImageUploader from "./components/ImageUploader.vue"
app.component("dtc-image-uploader", ImageUploader);
import ImageCollectionUploader from "./components/ImageCollectionUploader.vue"
app.component("dtc-image-collection-uploader", ImageCollectionUploader);

import ProductIndex from "./components/products/ProductIndex.vue"
app.component("dtc-products-index", ProductIndex);
import EquipmentPrint from "./components/equipment/EquipmentPrint.vue"
app.component("dtc-equipment-print", EquipmentPrint);
import EquipmentIndex from "./components/equipment/EquipmentIndex.vue"
app.component("dtc-equipment-index", EquipmentIndex);
import EquipmentIndexTable from "./components/equipment/EquipmentIndexTable.vue"
app.component("dtc-equipment-index-table", EquipmentIndexTable);
import EquipmentTable from "./components/equipment/EquipmentTable.vue"
app.component("dtc-equipment-table", EquipmentTable);
import EquipmentsCalendar from "./components/equipment/EquipmentsCalendar.vue"
app.component("dtc-equipments-calendar", EquipmentsCalendar);

import EquipmentStatus from "./components/equipment/EquipmentStatus.vue"
app.component("dtc-equipment-status", EquipmentStatus);
import EquipmentHealthState from "./components/equipment/EquipmentHealthState.vue"
app.component("dtc-equipment-health-state", EquipmentHealthState);
import TestStatus from "./components/equipment/TestStatus.vue"
app.component("dtc-test-status", TestStatus);

import AssignToAnotherModelButton from "./components/equipment/AssignToAnotherModelButton.vue";
app.component("dtc-assign-to-another-model-button", AssignToAnotherModelButton);

import EquipmentHistory from "@/components/equipment/EquipmentHistory.vue";
app.component("dtc-equipment-history", EquipmentHistory);

import MaintenanceRecordIndex from "@/components/maintenance/MaintenanceRecordIndex.vue";
app.component("dtc-maintenance-record-index", MaintenanceRecordIndex);

import ReviewIndex from "./components/reviews/ReviewIndex.vue"
app.component("dtc-review-index", ReviewIndex);

import StartProductTest from "./components/product-test/StartProductTest.vue"
app.component("dtc-start-product-test", StartProductTest);

import ProductTestIndex from "./components/product-test/ProductTestIndex.vue"
app.component("dtc-product-test-index", ProductTestIndex);

import ProductTestRulesConfig from "./components/product-test/ProductTestRulesConfig.vue"
app.component("product-test-rules-config", ProductTestRulesConfig);

import ExponentsList from "./components/ExponentsList.vue"
app.component("dtc-exponents-list", ExponentsList);
import TourList from "./components/Tour/TourList.vue"
app.component("dtc-tour-list", TourList);

import ToursWithParksSelector from "./components/Tour/ToursWithParksSelector.vue"
app.component('tours-with-parks-selector', ToursWithParksSelector);

import OrganizationSearchableList from "./components/Organization/OrganizationSearchableList.vue"
app.component("dtc-organization-list", OrganizationSearchableList);
import AddExponentToOrganization from "./components/Organization/AddExponent.vue"
app.component("add-exponent-to-organization", AddExponentToOrganization);


import TourExponentIndex from "./components/Tour/TourExponentIndex.vue"
app.component("dtc-tour-exponent-index", TourExponentIndex);

import ResendInvitationDialog from "./components/Tour/ResendInvitationDialog.vue"
app.component("dtc-resend-invitation-dialog", ResendInvitationDialog);

import ConfirmParticipationDialog from "./components/Tour/ConfirmParticipationDialog.vue"
app.component("dtc-confirm-participation-dialog", ConfirmParticipationDialog);

import BrandsSelector from "./components/brands/BrandsSelector.vue"
app.component("dtc-brands-selector", BrandsSelector);

import ReviewCriteriaOrder from "./components/products/ReviewCriteriaOrder.vue"
app.component("dtc-review-criteria-order", ReviewCriteriaOrder);

import ProductReferenceAliases from "./components/products/ProductReferenceAliases.vue"
app.component("dtc-product-reference-aliases", ProductReferenceAliases);

/** Marketing Message Components */
import Properties from "./components/marketing-message/Properties.vue"
app.component("dtc-marketing-message-properties", Properties);

import EmailMessage from "./components/marketing-message/EmailMessage.vue"
app.component("dtc-marketing-message-email-message", EmailMessage);

import TextMessage from "./components/marketing-message/TextMessage.vue"
app.component("dtc-marketing-message-text-message", TextMessage);

import ImportDynamicContents from "./components/marketing-message/ImportDynamicContents.vue"
app.component("dtc-marketing-message-import-dynamic-contents", ImportDynamicContents);
import ShowDynamicContents from "./components/marketing-message/ShowDynamicContents.vue"
app.component("dtc-marketing-message-show-dynamic-contents", ShowDynamicContents);

import SegmentSetup from "./components/marketing-message/registration-segment/SegmentSetup.vue"
app.component("dtc-marketing-message-registration-segment-setup", SegmentSetup);

import MetafieldListOrdering from "@/components/metafield/MetafieldListOrdering.vue";
app.component("dtc-metafield-list-ordering", MetafieldListOrdering);

import ThirdPartySynchronizationStatus from '@/components/third-party/ThirdPartySynchronizationStatus.vue'
app.component("dtc-third-party-synchronization-status", ThirdPartySynchronizationStatus);

import ExtraParameters from '@/components/third-party/ExtraParameters.vue'
app.component("dtc-third-party-extra-parameters", ExtraParameters);

import ShopifyInstallTourSelector from '@/components/shopify/ShopifyInstallTourSelector.vue'
app.component("dtc-shopify-install-tour-selector", ShopifyInstallTourSelector);

/** Chart Components **/
import HorizontalBarChart from "./components/charts/HorizontalBarChart.vue"
app.component("horizontal-bar-chart", HorizontalBarChart);
import BarChart from "./components/charts/BarChart.vue"
app.component("bar-chart", BarChart);
import LineChart from "./components/charts/LineChart.vue"
app.component("line-chart", LineChart);
import DoughnutChart from "./components/charts/DoughnutChart.vue"
app.component("doughnut-chart", DoughnutChart);

import editor from "./components/wysiwyg/TipTapEditor.vue"
app.component("wysiwyg-editor", editor);

import InputPrice from "./components/ui/InputPrice.vue"
app.component("input-price", InputPrice);
import ActivityPrice from "./components/ActivityPrice.vue"
app.component("activity-price", ActivityPrice);
import InputDateTime from "./components/InputDateTime.vue"
app.component("input-date-time", InputDateTime);

import ActivityListOrder from "@/components/activity/ActivityListOrder.vue"
app.component("dtc-activity-list-order", ActivityListOrder);
import ActivityVariantList from "@/components/activity/ActivityVariantList.vue";
app.component("dtc-activity-variant-list", ActivityVariantList);
import ActivityOptionListOrder from "@/components/activity/ActivityOptionListOrder.vue"
app.component("dtc-activity-option-list-order", ActivityOptionListOrder);
import ActivityOptionValueListOrder from "@/components/activity/ActivityOptionValueListOrder.vue"
app.component("dtc-activity-option-values-order", ActivityOptionValueListOrder);
import ActivityCategoryListOrder from "@/components/activity/ActivityCategoryListOrder.vue"
app.component("dtc-activity-category-list-order", ActivityCategoryListOrder);



import LocalesSetting from "./components/LocalesSetting.vue"
app.component("locales-setting", LocalesSetting);

import LocaleStatusBadge from "./components/ui/LocaleStatusBadge.vue"
app.component("dtc-locale-status-badge", LocaleStatusBadge);
import Timezone from "./components/form-components/Timezone.vue"
app.component("timezone", Timezone);
import TourTimezoneAndDatesSetting from "./components/Tour/TourTimezoneAndDatesSetting.vue"
app.component("tour-timezone-and-dates-setting", TourTimezoneAndDatesSetting);
import TemplateSelector from "./components/Tour/TemplateSelector.vue"
app.component("dtc-template-selector", TemplateSelector);
import ChangeSlugDialog from "./components/Tour/ChangeSlugDialog.vue"
app.component("dtc-change-slug-dialog", ChangeSlugDialog);

import TranslatableForm from "./components/TranslatableForm.vue"
app.component("translatable-form", TranslatableForm);

import Rating from "./components/Rating.vue"
app.component("dtc-rating", Rating);

import Duration from "./components/Duration.vue"
app.component("duration", Duration);

import DropZone from "./components/DropZone.vue"
app.component("dropzone", DropZone);

import PermissionsList from "./components/permission/PermissionsList.vue"
app.component("users-permissions-list", PermissionsList);

import NotificationSubscription from "./components/notification/NotificationSubscription.vue"
app.component("dtc-notification-subscription", NotificationSubscription);
import NotificationPreferences from "./components/notification/NotificationPreferences.vue"
app.component("dtc-notification-preferences", NotificationPreferences);
import NotificationExceptions from "./components/notification/NotificationExceptions.vue"
app.component("dtc-notification-exceptions", NotificationExceptions);

import OrderIndex from "./components/orders/OrderIndex.vue"
app.component("dtc-orders-index", OrderIndex);
import OrderItemIndex from "./components/orders/OrderItemIndex.vue"
app.component("dtc-order-items-index", OrderItemIndex);
import EditActivityQuotaStats from "./components/orders/EditActivityQuotaStats.vue"
app.component("edit-activity-quota-stats", EditActivityQuotaStats);

import ChangeRegistration from "./components/orders/ChangeRegistration.vue"
app.component("order-change-registration", ChangeRegistration);
import EditOrderItemActivityVariant from "./components/orders/EditOrderItemActivityVariant.vue"
app.component("edit-order-item-activity-variant", EditOrderItemActivityVariant);
import AddOrderItemActivityVariant from "./components/orders/AddOrderItemActivityVariant.vue"
app.component("add-order-item-activity-variant", AddOrderItemActivityVariant);

import VariantsSelectModal from "./components/promotion/VariantsSelectModal.vue"
app.component("variants-select-modal", VariantsSelectModal);
import VariantsSelect from "./components/promotion/VariantsSelect.vue"
app.component("variants-select", VariantsSelect);
import CriteriaAndVariantsSelect from "./components/promotion/CriteriaAndVariantsSelect.vue"
app.component("promotion-criteria-and-variants-select", CriteriaAndVariantsSelect);

import SearchableDeposit from "./components/payment/SearchableDeposit.vue"
app.component("dtc-searchable-deposits-list", SearchableDeposit)
import DepositBatchCreation from "./components/payment/DepositBatchCreation.vue";
app.component("dtc-deposit-batch-creation", DepositBatchCreation);
import CreateDeposit from "./components/payment/CreateDeposit.vue"
app.component("create-deposit", CreateDeposit);
import DepositSearch from "./components/payment/DepositSearch.vue"
app.component("deposits-search", DepositSearch);

import PaymentSearch from "./components/payment/PaymentSearch.vue"
app.component("dtc-payment-search", PaymentSearch);

import DateAlert from "./components/DateAlert.vue"
app.component("date-alert", DateAlert);

import QuotaIndicator from "./components/QuotaIndicator.vue"
app.component("quota-indicator", QuotaIndicator);
import { UsageIndicator } from "@/shadcn/components/ui/usage-indicator/index.js";
app.component("dtc-usage-indicator", UsageIndicator);

import Avatar from './components/ui/Avatar.vue'
app.component("avatar", Avatar);

import {
  Badge
} from "./components/ui/badge";
app.component("dtc-badge", Badge);

import {
  Dialog,
  DialogContent,
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogScrollContent,
  DialogTitle,
  DialogTrigger,
} from './components/ui/dialog'
app.component("dtc-dialog", Dialog);
app.component("dtc-dialog-content", DialogContent);
app.component("dtc-dialog-close", DialogClose);
app.component("dtc-dialog-description", DialogDescription);
app.component("dtc-dialog-footer", DialogFooter);
app.component("dtc-dialog-header", DialogHeader);
app.component("dtc-dialog-overlay", DialogOverlay);
app.component("dtc-dialog-scroll-content", DialogScrollContent);
app.component("dtc-dialog-title", DialogTitle);
app.component("dtc-dialog-trigger", DialogTrigger);

import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogTitle,
  AlertDialogFooter,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/shadcn/components/ui/alert-dialog";
app.component("dtc-alert-dialog", AlertDialog);
app.component("dtc-alert-dialog-trigger", AlertDialogTrigger);
app.component("dtc-alert-dialog-header", AlertDialogHeader);
app.component("dtc-alert-dialog-content", AlertDialogContent);
app.component("dtc-alert-dialog-title", AlertDialogTitle);
app.component("dtc-alert-dialog-footer", AlertDialogFooter);
app.component("dtc-alert-dialog-description", AlertDialogDescription);
app.component("dtc-alert-dialog-cancel", AlertDialogCancel);
app.component("dtc-alert-dialog-action", AlertDialogAction);

import { Icon } from "./components/ui/icon";
app.component("dtc-icon", Icon);

import LocationSetting from "./components/location/LocationSetting.vue"
app.component("dtc-location-setting", LocationSetting);
import LocationSelector from "./components/location/LocationSelector.vue"
app.component("dtc-location-selector", LocationSelector);

import Vapor from "laravel-vapor";
window.Vapor = Vapor;

import StoreSlotConfig from "@/components/store/StoreConfig.vue";
app.component("store-config", StoreSlotConfig);
import CartCountdown from "@/components/orders/CartCountdown.vue";
app.component("cart-countdown", CartCountdown);

import ValidateRegistration from "@/components/registration/ValidateRegistration.vue";
app.component("validate-registration", ValidateRegistration);
import RegistrationIndex from "@/components/registration/RegistrationIndex.vue"
app.component("dtc-registration-index", RegistrationIndex);
import OrganizationRegistrationIndex from "@/components/registration/OrganizationRegistrationIndex.vue"
app.component("dtc-organization-registration-index", OrganizationRegistrationIndex);

import PasswordVisibilityToggler from "@/components/form-components/PasswordVisibilityToggler.vue";
app.component("password-visibility-toggler", PasswordVisibilityToggler);

import HeaderNav from "./components/HeaderNav.vue"
app.component("header-nav", HeaderNav);
import OptionForm from "@/components/form-components/OptionForm.vue";
app.component("dtc-option-form", OptionForm);

import PageReloader from "@/components/PageReloader.vue";
app.component("dtc-page-reloader", PageReloader);
import DtcCollapsible from "@/components/ui/Collapsible.vue";
app.component("dtc-collapsible", DtcCollapsible);

import {CollapsibleTrigger, CollapsibleContent} from "@/shadcn/components/ui/collapsible";
app.component("CollapsibleTrigger", CollapsibleTrigger);
app.component("CollapsibleContent", CollapsibleContent);

import {DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator} from "@/shadcn/components/ui/dropdown-menu";
app.component("dtc-dropdown-menu", DropdownMenu);
app.component("dtc-dropdown-menu-trigger", DropdownMenuTrigger);
app.component("dtc-dropdown-menu-content", DropdownMenuContent);
app.component("dtc-dropdown-menu-item", DropdownMenuItem);
app.component("dtc-dropdown-menu-separator", DropdownMenuSeparator);

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/shadcn/components/ui/tabs'
app.component("Tabs", Tabs);
app.component("TabsContent", TabsContent);
app.component("TabsList", TabsList);
app.component("TabsTrigger", TabsTrigger);

import DtcAlert from "@/components/ui/Alert.vue";
app.component("dtc-alert", DtcAlert);

import DtcCombobox from "@/components/ui/Combobox.vue";
app.component("dtc-combobox", DtcCombobox);

import Tooltip from "@/components/ui/Tooltip.vue";
app.component("dtc-tooltip", Tooltip);

import { Toaster } from "@/shadcn/components/ui/sonner";
app.component("dtc-toaster", Toaster);

import { Button } from "@/shadcn/components/ui/button";
app.component("dtc-button", Button);

import FormSwitch from "@/components/ui/FormSwitch.vue";
app.component("dtc-form-switch", FormSwitch);

import CustomHeadersEditor from "@/components/webhook/CustomHeadersEditor.vue";
app.component("dtc-webhook-custom-headers", CustomHeadersEditor);

import JobBatchStatus from "@/components/JobBatchStatus.vue";
app.component("dtc-job-batch-status", JobBatchStatus);

import ProductImport from "@/components/products/ProductImport.vue";
app.component("product-import", ProductImport);

import InlineTermsDialog from "@/components/terms/InlineTermsDialog.vue";
app.component("dtc-inline-terms-dialog", InlineTermsDialog);

import BarcodeOrderForm from "./components/barcode-order/BarcodeOrderForm.vue"
app.component("dtc-barcode-order-form", BarcodeOrderForm);
import BarcodeOrderStockSelector from "./components/barcode-order/BarcodeOrderStockSelector.vue"
app.component("dtc-barcode-order-stock-selector", BarcodeOrderStockSelector);

// Mount the Vue app
app.mount('#app')
